var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 1.33398V8.00065C9.9987 8.73398 9.3987 9.33398 8.66536 9.33398H1.33203V4.00065C1.33203 2.52732 2.52536 1.33398 3.9987 1.33398H9.9987Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 9.33398V11.334C14.6654 12.4407 13.772 13.334 12.6654 13.334H11.9987C11.9987 12.6007 11.3987 12.0007 10.6654 12.0007C9.93203 12.0007 9.33203 12.6007 9.33203 13.334H6.66536C6.66536 12.6007 6.06536 12.0007 5.33203 12.0007C4.5987 12.0007 3.9987 12.6007 3.9987 13.334H3.33203C2.22536 13.334 1.33203 12.4407 1.33203 11.334V9.33398H8.66536C9.3987 9.33398 9.9987 8.73398 9.9987 8.00065V3.33398H11.2254C11.7054 3.33398 12.1454 3.59399 12.3854 4.00732L13.5254 6.00065H12.6654C12.2987 6.00065 11.9987 6.30065 11.9987 6.66732V8.66732C11.9987 9.03398 12.2987 9.33398 12.6654 9.33398H14.6654Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 14.6667C11.4017 14.6667 11.9987 14.0697 11.9987 13.3333C11.9987 12.597 11.4017 12 10.6654 12C9.92898 12 9.33203 12.597 9.33203 13.3333C9.33203 14.0697 9.92898 14.6667 10.6654 14.6667Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8V9.33333H12.6667C12.3 9.33333 12 9.03333 12 8.66667V6.66667C12 6.3 12.3 6 12.6667 6H13.5267L14.6667 8Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.7c94ebfd64e619630d65c0ba0df66b93.svg";
export { ForwardRef as ReactComponent };